<div class="container-fluid">
  <div class="jumbotron text-center hero-background">
    <h2 class="text-white">The entire rental process, handled.</h2>
    <p class="lead text-white mb-5">We do it all so you don't have to.</p>
    <div class="d-md-flex justify-content-center">
      <button class="btn btn-primary btn-lg mr-md-4 fixed-height" commonEventTracker="home-how-it-works-video-btn-click" (click)="watchVideo()">
        <div class="d-flex align-items-center"><i class="icon-play-button fs-29 ml-3"></i>See how it works</div>
      </button>
      <button
        class="btn btn-outline-light btn-lg d-none d-md-block"
        commonEventTracker="home-how-it-works-learn-more-btn-click"
        [routerLink]="['/lp/rent-machines']"
      >
        Learn more
      </button>
    </div>
    <button
      class="btn btn-outline-light btn-lg mt-3 d-md-none"
      commonEventTracker="home-how-it-works-learn-more-btn-click"
      [routerLink]="['/lp/rent-machines']"
    >
      Learn more
    </button>
  </div>
</div>
